import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../../api';
import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Vendor Repair',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Vendor Repair',
        href: '/adm/opr/eor/vendor-repair',
        active: true,
      },
    ],
    items: [],
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_vendor_repair',
    sortDesc: true,
    fields: [
      {
        key: 'code',
        sortable: true,
      },
      {
        key: 'vendor_name',
        label: 'Vendor Name',
        sortable: true,
      },
      {
        key: 'address',
        label: 'Address',
      },
      {
        key: 'email',
        label: 'Email',
      },
      {
        key: 'phone',
        label: 'Phone',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    form: {
      code: '',
      name: '',
      address: '',
      phone: '',
    },
    loading: false,
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeVendorRepair(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchVendor(context, payload) {
    let result = await ApiGetRequest(`opr/vendor-repair`, payload);
    return !result.error ? result.data.object : [];
  },

  async getListVendorRepair({ commit, state }) {
    commit('changeVendorRepair', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`opr/vendor-repair`, params);
    commit('changeVendorRepair', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailVendorRepair({ commit }, payload = null) {
    console.log('call hereee');
    commit('changeVendorRepair', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/vendor-repair/${payload.id}`);
    commit('changeVendorRepair', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeVendorRepair', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`opr/vendor-repair/import`, {
      items: data.import_form || [],
    });

    commit('changeVendorRepair', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createVendorRepair({ state, commit, dispatch }) {
    commit('changeVendorRepair', {
      loading: true,
    });

    let result = await ApiPostRequest(`opr/vendor-repair`, state.data.form);
    commit('changeVendorRepair', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateVendorRepair({ commit, state, dispatch }, payload = null) {
    commit('changeVendorRepair', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `opr/vendor-repair/${payload.id}`,
      state.data.form
    );

    commit('changeVendorRepair', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteVendorRepair({ commit, dispatch }, payload = null) {
    commit('changeVendorRepair', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/vendor-repair/${payload.id}`);
    commit('changeVendorRepair', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
